import { Component } from 'react'
import { Modal } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'
import { PrimaryButton, SecondaryButton } from '../styles/Buttons'
interface Props {
    show: boolean
    onHide: Function
    title: string
    body: string
    confirmText: string
    cancelText: string
    onConfirm: Function
}

class Confirm extends Component<Props, any> {

    render() {
        const { title, body, onConfirm, confirmText, cancelText, ...rest } = this.props
        return (
            <>
                <Modal
                    {...rest}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered={true}
                    className={'SimutechModal'}
                >
                    <Modal.Header closeButton={false}>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {ReactHtmlParser(body)}
                    </Modal.Body>
                    <Modal.Footer>
                        <PrimaryButton onClick={onConfirm}>{confirmText}</PrimaryButton>
                        <SecondaryButton onClick={this.props.onHide}>{cancelText}</SecondaryButton>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

export default Confirm